import { genUUID } from "../utils/slug";
import { replaceVariable } from "../utils/string";

/**
 * Root class for Dutycast compoment loader.
 * @example
 * 
 * export default class NewCompoment extends DComponent {
 *    constructor({
 *      parent,
 *      id,
 *      customParam,
 *    } = {}) {
 *      super(arguments[0], parent, id, {
 *        class: "NewCompoment",
 *      }, false, false);
 *      this.customParam = customParam;
 *      this.render();
 *    }
 * 
 *    loadStyle() {
 *      const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
 *      this.appendStyle(style)
 *    }
 * 
 *    loadHtml() {
 *      return require("html-loader!./index.html");
 *    }
 * 
 *    after() {
 *    }
 * }
 */
export class DComponent {
  /**
   * Creates an instance of DComponent.
   * @param {{}} [arg={}]
   * @param {string} [parent="body"]
   * @param {string} [id=genUUID()]
   * @param {{}} [variables={}]
   * @param {boolean} [awaitStyle=false]
   * @param {boolean} [defaultLoading=false]
   * @memberof DComponent
   */
  constructor(
    arg = {},
    parent = "body",
    id = genUUID(),
    variables = {},
    awaitStyle = false,
    defaultLoading = false,
    loading = true
  ) {
    this.id = id;
    this.parent = $(parent);
    this.variables = variables;
    this.awaitStyle = awaitStyle;
    this.defaultLoading = defaultLoading;
    this.htmlBeforeStyle = true;
    this.arg = arg;
    this.loading = loading;
    this.idElement = "";
  }

  render() {
    this.before(this.arg);
    if (this.htmlBeforeStyle) {
      this.genElement(this.arg);
      this.parentAppend(this.arg);
      this.afterElement(this.arg);
    }

    this.loadStyle();

    if (!this.htmlBeforeStyle) {
      this.genElement(this.arg);
      this.parentAppend(this.arg);
      this.afterElement(this.arg);
    }

    if (this.defaultLoading && this.idElement) {
      if (this.parent.find(`> .${this.idElement}.default`).length) {
        this.parent.find(`> .${this.idElement}.default`).remove();
      }
    }
    this.after(this.arg);
    this.element.i18n();
    this.element.prop("DComponent", this);
    this.setLoading(false);
  }

  /**
   * Function load style file (Require overwrite).
   *
   * @example
   * loadStyle() {
   *   const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
   *   this.appendStyle(style)
   * }
   * 
   */
  loadStyle() {

  }

  /**
   * Function append style to body.
   *
   * @memberof DComponent
   */
  appendStyle(style, id) {
    if (!this.defaultLoading && !document.getElementById("style_" + id)) {
      const e = document.createElement("style");
      e.textContent = style;
      e.id = "style_" + id;
      document.body.append(e);
    }
    this.idElement = id;
  }

  /**
   * Function load html file (Require overwrite).
   * 
   * @example
   * loadHtml() {
   *   return require("html-loader!./index.html");
   * }
   * 
   */
  loadHtml() {
    // return require("html-loader!./index.html");
  }

  /**
   * Function will be call before append element.
   *
   * @memberof DComponent
   */
  before() {
    // do any before append element
  }

  /**
   * Function will be call after append element.
   *
   * @memberof DComponent
   */
  afterElement() {
    // do any after append element
  }

  /**
   * Function will be call after load style.
   *
   * @memberof DComponent
   */
  after() {
    // do any after load style
  }

  /**
   * Function define how to generate element.
   *
   * @memberof DComponent
   * 
   * @default
   * genElement() {
   *   this.element = $(replaceVariable(this.loadHtml(), {
   *     id: this.id,
   *     ...this.variables
   *   }));
   * }
   * 
   */
  genElement() {
    this.element = $(replaceVariable(this.loadHtml(), {
      id: this.id,
      ...this.variables
    }));
  }

  /**
   * Function define how append element to parent.
   * (.append, .prepent, .after, .before ...)
   *
   * @memberof DComponent
   * 
   * @default
   * parentAppend() {
   *   this.parent.append(this.element);
   * }
   * 
   */
  parentAppend() {
    this.parent.append(this.element);
  }

  /**
   * Function will be call reload element.
   *
   * @memberof DComponent
   */
  reloadElement() {
    this.parent.find("#" + this.id).remove();
    this.genElement(this.arg);
    this.parentAppend();
    this.reload();
    this.element.i18n();
  }

  /**
   * Function will be call after reload element.
   *
   * @memberof DComponent
   */
  reload() {

  }

  /**
   * Function will be call update append element.
   *
   * @memberof DComponent
   */
  update() {
    this.element.i18n();
    // do any update append element
  }

  /**
  * Function will be call destroy append element.
  *
  * @memberof DComponent
  */
  destroy() {
    this.element.remove();
    // do any destroy append element
  }

  /**
  * Function set loading component.
  *
  * @memberof DComponent
  */
  setLoading(loading) {
    this.loading = loading;
  }

  /**
  * Function get loading component.
  *
  * @memberof DComponent
  */
  getLoading() {
    return this.loading;
  }
}


$.fn.DComponent = function () {
  return this.prop("DComponent");
};
